import { type ColDef, type SpanRowsParams, themeQuartz } from "ag-grid-community"

import { type PricingGridRow } from "../types"

export const NON_EDITABLE_CELL_CLASS = "bg-gray-300 text-gray-700"

const DEFAULT_COLUMN_PROPS: ColDef<PricingGridRow> = {
  width: 130,
  sortable: false,
  resizable: false,
  headerClass: NON_EDITABLE_CELL_CLASS,
}

const NUMERIC_PROPS: ColDef<PricingGridRow> = {
  cellEditor: "agNumberCellEditor",
  // FIXME: issue with alignment when there is a background
  type: "rightAligned",
  cellEditorParams: {
    min: 0,
  },
}

const DATE_PROPS: ColDef<PricingGridRow> = {
  // FIXME: date picker (edit format)
  cellEditor: "agDateStringCellEditor",
  cellDataType: "dateString",
  width: 150,
  cellEditorParams: {},
}

const SPANNED_PROPS: ColDef<PricingGridRow> = {
  spanRows: ({ valueA, valueB, nodeA, nodeB }: SpanRowsParams<PricingGridRow>) =>
    valueA === valueB && nodeA?.data?.item === nodeB?.data?.item,
}

export const COLUMN_PROPS: Record<string, ColDef<PricingGridRow>> = {
  DEFAULT: DEFAULT_COLUMN_PROPS,
  DATE: DATE_PROPS,
  NUMERIC: NUMERIC_PROPS,
  SPANNED: SPANNED_PROPS,
}

export const MARGIN_THRESHOLDS = { LOW: 10, MEDIUM: 20 } as const

export const PRICING_GRID_THEME = themeQuartz.withParams({ borderRadius: 0, wrapperBorderRadius: 0 })
